<div class="searchbar">
    <ntv-searchbar
        [size]="size()"
        [placeholder]="placeholder()"
        [hideOuterSearchButton]="hideOuterSearchButton()"
        [enableAutoComplete]="false"
        [showClearButton]="showClearButton()"
        [minCharacters]="minCharacters()"
        (keydown.enter)="onEnterKey($event)">
        <div left-icon class="search-icon-wrapper">
            <svg width="14" height="14">
                <use [attr.href]="spritePath + '#' + icons['sparkles']"></use>
            </svg>
        </div>

        @if (!isHiddenForNow()) {
            <div right-addon class="sparkle-icon-wrapper">
                <svg width="14" height="14">
                    <use [attr.href]="spritePath + '#' + icons['sparkles']"></use>
                </svg>
            </div>
        }
    </ntv-searchbar>
</div>
